module.exports = __webpack_public_path__ + "img/email.aca25a96.svg";